import React from "react";
import PageHeader from "../components/PageHeader";
import { committee } from "../mock";
import { useReveal } from "../hooks/useReveal";

const Committee = () => {
  useReveal();
  return (
    <div>
      <PageHeader title="Organising Committee" crumb="Committee" subtitle="Distinguished leaders steering the vision of DRS 2026." />
      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {committee.map((p) => (
              <div key={p.name} className="reveal group text-center">
                <div className="card-hover relative aspect-square rounded-2xl overflow-hidden bg-slate-100 border border-slate-100">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-x-0 bottom-0 h-1.5 bg-brand" />
                </div>
                <h3 className="mt-4 font-display font-bold text-navy-900">{p.name}</h3>
                <p className="text-sm text-brand font-medium">{p.role}</p>
                {p.org && <p className="text-xs text-slate-500 mt-0.5">{p.org}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Committee;
